export default __webpack_public_path__ + "static/media/sticker-ad.bb23d251.png";